import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import Loader from "../../components/utils/Loader";
import useFetch from "../../hooks/useFetch";
import MainLayout from "../../layouts/MainLayout";
import DatePicker from 'react-datepicker';

import AILightComponent from "../../components/AILightComponent";
import ChatGPTComponents from "../../components/ChatGPTComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMicrophone,
  faMicrophoneSlash,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import SpeechRecognitionComponent from "../../components/SpeechRecognitionComponent";
import "../../styles/Concerns.css";
import { GenerateRCACode } from "../../components/GenerateThink5whysCode";
import axios from "axios";
import CompleteRCAPDFGenerator from './CompleteRCAPDFGenerator';

const RCAExtensionForm = () => {
  const authState = useSelector((state) => state.authReducer);
  const [fetchData, { loading }] = useFetch();
  const location = useLocation();
  const navigate = useNavigate();

  const { formData } = location.state;
  const { rcaId } = location.state;
  const { rcaCode } = location.state;
  const { concernArea } = location.state;
  const [error, setError] = useState(null);

  // console.log("Received formData:", formData);
  // console.log("Received rcaId:", rcaId);
  // console.log("Received rcaCode:", rcaCode);
  // console.log("Received concernArea:", concernArea);
  
  const { rcaExtensionId } = useParams();
  const mode = rcaExtensionId === undefined ? "add" : "update";
  const [countFormErrors, setCountFormErrors] = useState(0);
  const [formErrors, setFormErrors] = useState({});
  const [isCheckedAISupport, setIsCheckedAISupport] = useState(false);
  const [showMicrophoneAlert, setShowMicrophoneAlert] = useState(false);
  const [showSolutionNotes, setShowSolutionNotes] = useState(false);

  //   const { concernArea } = location.state.formData.rcaId;
  //   const { problemStatement } = location.state.formData.rcaId;

  //   const [rcaId, setRCAId] = useState('');
  //   setRCAId(formData.rcaId);
  // console.log("---", rcaId);

  const [rcaExists, setRcaExists] = useState(false);

  const [rcaExtension, setRcaExtension] = useState({
    rcaId: rcaId,
    rcaCode: rcaCode,
    category: formData.category,
    subCategory: formData.subCategory,
    concernArea: formData.concernArea,
    problemStatement: formData.problemStatement,
    impact: [
      { sn: 1, details: '' },
      { sn: 2, details: '' },
      { sn: 3, details: '' },
      { sn: 4, details: '' },
      { sn: 5, details: '' }
    ],
    overallImpact: '',
    overallImpactOn: '',
    overallImpactSeverity: '',
    problemStatementRemarks: '',

    why1: formData.why1,
    why1reasons: [
      { sn: 1, details: '' },
      { sn: 2, details: '' },
      { sn: 3, details: '' },
      { sn: 4, details: '' },
      { sn: 5, details: '' }
    ],
    why1SelectedSN: 0,
    why1SNSelectedReason: '',
    why1remarks: '',
    
    why2: formData.why2,
    why2reasons: [
      { sn: 1, details: '' },
      { sn: 2, details: '' },
      { sn: 3, details: '' },
      { sn: 4, details: '' },
      { sn: 5, details: '' }
    ],
    why2SelectedSN: 0,
    why2SNSelectedReason: '',
    why2remarks: '',

    why3: formData.why3,
    why3reasons: [
      { sn: 1, details: '' },
      { sn: 2, details: '' },
      { sn: 3, details: '' },
      { sn: 4, details: '' },
      { sn: 5, details: '' }
    ],
    why3SelectedSN: 0,
    why3SNSelectedReason: '',
    why3remarks: '',

    why4: formData.why4,
    why4reasons: [
      { sn: 1, details: '' },
      { sn: 2, details: '' },
      { sn: 3, details: '' },
      { sn: 4, details: '' },
      { sn: 5, details: '' }
    ],
    why4SelectedSN: 0,
    why4SNSelectedReason: '',
    why4remarks: '',

    why5: formData.why5,
    why5reasons: [
      { sn: 1, details: '' },
      { sn: 2, details: '' },
      { sn: 3, details: '' },
      { sn: 4, details: '' },
      { sn: 5, details: '' }
    ],
    why5SelectedSN: 0,
    why5SNSelectedReason: '',
    why5remarks: '',

    rcaCauses: [
      { sn: 1, details: '' },
      { sn: 2, details: '' },
      { sn: 3, details: '' },
      { sn: 4, details: '' },
      { sn: 5, details: '' }
    ],
    selectedCause: 0,
    rootCause: formData.rootCause,
    rcaRemarks: formData.summary,

    decisionRoute: '',

    probableSolutions: [
      { sn: 1, details: '' },
      { sn: 2, details: '' },
      { sn: 3, details: '' },
      { sn: 4, details: '' },
      { sn: 5, details: '' },
      { sn: 6, details: '' },
      { sn: 7, details: '' },
      { sn: 8, details: '' },
      { sn: 9, details: '' },
      { sn: 10, details: '' }
    ],
    selectedQFSolution: 0,
    selectedQFSolutionRemarks: '',
    selectedLTSolution: 0,
    selectedLTSolutionRemarks: '',

    solutionActions: [
      { sn: 1, actionItem: '', who: '', priority: '', startDate: new Date(), endDate: new Date(), status: '', remarks: '' },
      { sn: 2, actionItem: '', who: '', priority: '', startDate: new Date(), endDate: new Date(), status: '', remarks: '' },
      { sn: 3, actionItem: '', who: '', priority: '', startDate: new Date(), endDate: new Date(), status: '', remarks: '' },
      { sn: 4, actionItem: '', who: '', priority: '', startDate: new Date(), endDate: new Date(), status: '', remarks: '' },
      { sn: 5, actionItem: '', who: '', priority: '', startDate: new Date(), endDate: new Date(), status: '', remarks: '' }
    ],

    problemKeywords: '',
    problemMeasures: '',
    problemOutcome: '',
    why1Keywords: '',
    why1Measures: '',
    why1Outcome: '',
    why2Keywords: '',
    why2Measures: '',
    why2Outcome: '',
    why3Keywords: '',
    why3Measures: '',
    why3Outcome: '',
    why4Keywords: '',
    why4Measures: '',
    why4Outcome: '',
    why5Keywords: '',
    why5Measures: '',
    why5Outcome: '',
    rcaKeywords: '',
    rcaMeasures: '',
    rcaOutcome: '',
    solutionKeywords: '',
    solutionMeasures: '',      
    solutionOutcome: '',
    
    openingRemarks: '',
    closingRemarks: '',
    expertCode: '',
    expertName: '',
    openingDate: new Date(),
    closingDate: new Date(),
    clientCode: '',
    clientName: '',
    clientRemarks: '',
    isExample: false,
    dateCreated: new Date(),
    createdBy: authState.user._id,
    isActive: true,
    isDeleted: false,
  });

  const [newWhy1Reason, setNewWhy1Reason] = useState({
    sn: 1,
    details: "",
  });

  const [newWhy2Reason, setNewWhy2Reason] = useState({
    sn: 1,
    details: "",
  });

  const [newWhy3Reason, setNewWhy3Reason] = useState({
    sn: 1,
    details: "",
  });

  const [newWhy4Reason, setNewWhy4Reason] = useState({
    sn: 1,
    details: "",
  });

  const [newWhy5Reason, setNewWhy5Reason] = useState({
    sn: 1,
    details: "",
  });

  const [newRca, setNewRca] = useState({
    sn: 1,
    details: "",
  });

  const [newProbableSolutions, setNewProbableSolutions] = useState({
    sn: 1,
    details: "",
  });

  const [newActions, setNewActions] = useState({
    sn: 1,
    actionItem: '',
    who: '',
    priority: '',
    startDate: null,
    endDate: null,
    status: '',
    remarks: ''
  });

  // console.log("Outside useEffect for Getting Data for rcaExtension Update here", rcaId);
  useEffect(() => {
    // console.log("Inside useEffect with dependencies", rcaId);
    if (rcaId !== '') {
      const config = { 
        url: `/rcaextension/getforupdate`, 
        method: "post", 
        headers: { Authorization: authState.token }, 
        data: { rcaId: rcaId }
      };
      // console.log("Getting Data for rcaExtension Update here", config);
  
      fetchData(config, { showSuccessToast: false })
        .then((data) => {
          // console.log("Response for rcaExtension update data status - ", data.status);
          // console.log("Response for rcaExtension update data - ", data.rcaExtension);
          if (data.status === false) {
            setRcaExists(false);
          } else {
            setRcaExists(true);
            setRcaExtension(data.rcaExtension);
          }
          // setRcaExists(true);
        })
        .catch((error) => {
          console.error("Error fetching RCA Extension data:", error);
          setRcaExists(true);
        });
    } 
  }, [rcaId, authState.token]);

  useEffect(() => {
    // console.log("Updated rcaExtension Object in useEffect - ", rcaExtension);
    // console.log("rcaExists in useEffect - ", rcaExists? "Found in DB":"Not Found in DB");
  }, [rcaExtension, rcaExists]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name in newWhy1Reason) {
      setNewWhy1Reason(prev => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value
      }));
    } else if (name in newWhy2Reason) {
      setNewWhy3Reason(prev => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value
      }));
    } if (name in newWhy3Reason) {
      setNewWhy3Reason(prev => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value
      }));
    } if (name in newWhy4Reason) {
      setNewWhy4Reason(prev => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value
      }));
    } if (name in newWhy5Reason) {
      setNewWhy5Reason(prev => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value
      }));
    } if (name in newProbableSolutions) {
      setNewProbableSolutions(prev => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value
      }));
    } if (name in newActions) {
      setNewActions(prev => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value
      }));
    } else {
      setRcaExtension(prev => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value
      }));
    }
  };

  // Function to handle changes in array fields
  const handleArrayChange = (index, field, value, arrayName) => {
    setRcaExtension(prev => {
      const updatedArray = [...prev[arrayName]];
      updatedArray[index] = { ...updatedArray[index], [field]: value };
      return { ...prev, [arrayName]: updatedArray };
    });
  };

  const handleImpactChange = (index, field, value) => {
    const newImpact = rcaExtension.impact.map((impact, i) =>
      i === index ? { ...impact, [field]: value } : impact
    );
    setRcaExtension({ ...rcaExtension, impact: newImpact });
  };

  const handleWhy1Change = (index, field, value) => {
    const newWhy1Reasons = rcaExtension.why1reasons.map((why1reasons, i) =>
      i === index ? { ...why1reasons, [field]: value } : why1reasons
    );
    setRcaExtension({ ...rcaExtension, why1reasons: newWhy1Reasons });
  };

  const handleWhy2Change = (index, field, value) => {
    const newWhy2Reasons = rcaExtension.why2reasons.map((why2reasons, i) =>
      i === index ? { ...why2reasons, [field]: value } : why2reasons
    );
    setRcaExtension({ ...rcaExtension, why2reasons: newWhy2Reasons });
  };

  const handleWhy3Change = (index, field, value) => {
    const newWhy3Reasons = rcaExtension.why3reasons.map((why3reasons, i) =>
      i === index ? { ...why3reasons, [field]: value } : why3reasons
    );
    setRcaExtension({ ...rcaExtension, why3reasons: newWhy3Reasons });
  };

  const handleWhy4Change = (index, field, value) => {
    const newWhy4Reasons = rcaExtension.why4reasons.map((why4reasons, i) =>
      i === index ? { ...why4reasons, [field]: value } : why4reasons
    );
    setRcaExtension({ ...rcaExtension, why4reasons: newWhy4Reasons });
  };

  const handleWhy5Change = (index, field, value) => {
    const newWhy5Reasons = rcaExtension.why5reasons.map((why5reasons, i) =>
      i === index ? { ...why5reasons, [field]: value } : why5reasons
    );
    setRcaExtension({ ...rcaExtension, why5reasons: newWhy5Reasons });
  };

  const handleRcaChange = (index, field, value) => {
    const newRcaCauses = rcaExtension.rcaCauses.map((rcaCauses, i) =>
      i === index ? { ...rcaCauses, [field]: value } : rcaCauses
    );
    setRcaExtension({ ...rcaExtension, rcaCauses: newRcaCauses });
  };

  const handleProbableSolutionsChange = (index, field, value) => {
    const newProbableSolutions = rcaExtension.probableSolutions.map((probableSolutions, i) =>
      i === index ? { ...probableSolutions, [field]: value } : probableSolutions
    );
    setRcaExtension({ ...rcaExtension, probableSolutions: newProbableSolutions });
  };

  const handleSolutionActionChange = (index, field, value) => {
    const newSolutionActions = rcaExtension.solutionActions.map((solutionAction, i) =>
      i === index ? { ...solutionAction, [field]: value instanceof Date ? value : value } : solutionAction
    );
    setRcaExtension({ ...rcaExtension, solutionActions: newSolutionActions });
  };

  // Function to add a new reason to the array
  const handleAddWhy1Reason = () => {
    if (rcaExtension.why1reasons.length < 5) {
      setRcaExtension(prev => ({
        ...prev,
        why1reasons: [...prev.why1reasons, newWhy1Reason],
      }));
      setNewWhy1Reason({
        sn: 1,
        details: "",
      });
    } else {
      alert("You can only add up to 5 reasons.");
    }
  };

  const handleAddWhy2Reason = () => {
    if (rcaExtension.why2reasons.length < 5) {
      setRcaExtension({
        ...rcaExtension,
        why2reasons: [...rcaExtension.why2reasons, newWhy2Reason],
      });
      setNewWhy2Reason({
        sn: 1,
        details: "",
      });
    } else {
      alert("You can only add up to 5 reasons.");
    }
  };

  const handleAddWhy3Reason = () => {
    if (rcaExtension.why3reasons.length < 5) {
      setRcaExtension({
        ...rcaExtension,
        why3reasons: [...rcaExtension.why3reasons, newWhy3Reason],
      });
      setNewWhy3Reason({
        sn: 1,
        details: "",
      });
    } else {
      alert("You can only add up to 5 reasons.");
    }
  };

  const handleAddWhy4Reason = () => {
    if (rcaExtension.why4reasons.length < 5) {
      setRcaExtension({
        ...rcaExtension,
        why4reasons: [...rcaExtension.why4reasons, newWhy4Reason],
      });
      setNewWhy4Reason({
        sn: 1,
        details: "",
      });
    } else {
      alert("You can only add up to 5 reasons.");
    }
  };

  const handleAddWhy5Reason = () => {
    if (rcaExtension.why5reasons.length < 5) {
      setRcaExtension({
        ...rcaExtension,
        why5reasons: [...rcaExtension.why5reasons, newWhy5Reason],
      });
      setNewWhy5Reason({
        sn: 1,
        details: "",
      });
    } else {
      alert("You can only add up to 5 reasons.");
    }
  };

  const handleAddRcaCause = () => {
    if (rcaExtension.rcaCauses.length < 5) {
      setRcaExtension({
        ...rcaExtension,
        rcaCauses: [...rcaExtension.rcaCauses, newRca],
      });
      setNewRca({
        sn: 1,
        details: "",
      });
    } else {
      alert("You can only add up to 5 reasons.");
    }
  };

  const handleAddProbableSolutions = () => {
    if (rcaExtension.probableSolutions.length < 10) {
        setRcaExtension({
        ...rcaExtension,
        probableSolutions: [...rcaExtension.probableSolutions, newProbableSolutions],
      });
      setNewProbableSolutions({
        sn: 1,
        details: "",
      });
    } else {
      alert("You can only add up to 10 suggestion.");
    }
  };

  const handleAddSolutionActions = () => {
    if (rcaExtension.solutionActions.length < 100) {
        setRcaExtension({
        ...rcaExtension,
        solutionActions: [...rcaExtension.solutionActions, newActions],
      });
      setNewActions({
        sn: 1,
        actionItem: '',
        who: '',
        priority: '',
        startDate: null,
        endDate: null,
        status: '',
        remarks: ''
      });
    } else {
      alert("You can only add up to 100 logs.");
    }
  };

  const handleSubmit = (e) => {
    // console.log("inside handleSubmit");

    // e.preventDefault();
    // const error = validateForm(rcaExtension);
    // console.log("error : ",error," no. of error",Object.keys(error).length);
    // setFormErrors(error);
    // setCountFormErrors(Object.keys(error).length);
    // console.log("setFormError : ",setFormErrors);

    // if (Object.keys(error).length > 0) {
    //   setFormErrors(
    //     Object.keys(error).reduce((total, key) => {
    //       total[key] = error[key];
    //       return total;
    //     }, {})
    //   );
    //   return;
    // }

    // console.log("Posting Data ", rcaExists ? `/rcaextension/${rcaId}` : "/rcaextension"," rcaExtensionid",rcaExtension._id," rcaId ",rcaId);
    const config = { 
      url: rcaExists ? "/rcaextension/update" : "/rcaextension",
      method: "post",
      data: {rcaExtension: rcaExtension, id: rcaExtension._id}, 
      headers: { Authorization: authState.token } 
    };
    // console.log("Posting Data Config", config);

    fetchData(config)
      .then((data) => {
        // console.log(rcaExists? "Update":"Create"+" Success:", data);
        navigate("/think5whys-extension-my"); 
      })
      .catch((error) => {
        console.error('There was an error!', error);
      });
  }

  const validateForm = formData => {
    const errors = {};
    if (!formData.problemStatement) {
      errors.problemStatement = "Problem Statement is require..";
    }
    return errors;
  }

  const fieldError = (field) => (
    <p className={`mt-1 text-pink-600 text-sm ${formErrors[field] ? "block" : "hidden"}`}>
      <i className='mr-2 fa-solid fa-circle-exclamation'></i>
      {formErrors[field]}
    </p>
  )

  // const [viewWhy1, setViewWhy1] = useState(false);
  // const [viewWhy2, setViewWhy2] = useState(false);
  // const [viewWhy3, setViewWhy3] = useState(false);
  // const [viewWhy4, setViewWhy4] = useState(false);
  // const [viewWhy5, setViewWhy5] = useState(false);
  // const [viewRCA, setViewRCA] = useState(false);
  // const [viewSolution, setViewSolution] = useState(false);
  // const [viewTree, setViewTree] = useState(false);
  // const [viewActions, setViewActions] = useState(false);
  // const [viewKeywords, setViewKeywords] = useState(false);
  // const [viewMeasures, setViewMeasures] = useState(false);
  // const [viewOutcome, setViewOutcome] = useState(false);
  // const [viewAddl, setViewAddl] = useState(false);

  // const handleWhy1Expansion = () => {
  //   setViewWhy1(prevState => !prevState);
  //   setViewWhy2(false);
  //   setViewWhy3(false);
  //   setViewWhy4(false);
  //   setViewWhy5(false);
  //   setViewRCA(false);
  //   setViewTree(false);
  //   setViewSolution(false);
  //   setViewActions(false);
  //   setViewKeywords(false);
  //   setViewMeasures(false);
  //   setViewOutcome(false);
  //   setViewAddl(false);
  // };

  // const handleWhy2Expansion = () => {
  //   setViewWhy1(false);
  //   setViewWhy2(prevState => !prevState);
  //   setViewWhy3(false);
  //   setViewWhy4(false);
  //   setViewWhy5(false);
  //   setViewRCA(false);
  //   setViewTree(false);
  //   setViewSolution(false);
  //   setViewActions(false);
  //   setViewKeywords(false);
  //   setViewMeasures(false);
  //   setViewOutcome(false);
  //   setViewAddl(false);
  // };

  // const handleWhy3Expansion = () => {
  //   setViewWhy1(false);
  //   setViewWhy2(false);
  //   setViewWhy3(prevState => !prevState);
  //   setViewWhy4(false);
  //   setViewWhy5(false);
  //   setViewRCA(false);
  //   setViewTree(false);
  //   setViewSolution(false);
  //   setViewActions(false);
  //   setViewKeywords(false);
  //   setViewMeasures(false);
  //   setViewOutcome(false);
  //   setViewAddl(false);
  // };

  // const handleWhy4Expansion = () => {
  //   setViewWhy1(false);
  //   setViewWhy2(false);
  //   setViewWhy3(false);
  //   setViewWhy4(prevState => !prevState);
  //   setViewWhy5(false);
  //   setViewRCA(false);
  //   setViewTree(false);
  //   setViewSolution(false);
  //   setViewActions(false);
  //   setViewKeywords(false);
  //   setViewMeasures(false);
  //   setViewOutcome(false);
  //   setViewAddl(false);
  // };

  // const handleWhy5Expansion = () => {
  //   setViewWhy1(false);
  //   setViewWhy2(false);
  //   setViewWhy3(false);
  //   setViewWhy4(false);
  //   setViewWhy5(prevState => !prevState);
  //   setViewRCA(false);
  //   setViewTree(false);
  //   setViewSolution(false);
  //   setViewActions(false);
  //   setViewKeywords(false);
  //   setViewMeasures(false);
  //   setViewOutcome(false);
  //   setViewAddl(false);
  // };

  // const handleRCAExpansion = () => {
  //   setViewWhy1(false);
  //   setViewWhy2(false);
  //   setViewWhy3(false);
  //   setViewWhy4(false);
  //   setViewWhy5(false);
  //   setViewRCA(prevState => !prevState);
  //   setViewTree(false);
  //   setViewSolution(false);
  //   setViewActions(false);
  //   setViewKeywords(false);
  //   setViewMeasures(false);
  //   setViewOutcome(false);
  //   setViewAddl(false);
  // };

  // const handleTreeExpansion = () => {
  //   setViewWhy1(false);
  //   setViewWhy2(false);
  //   setViewWhy3(false);
  //   setViewWhy4(false);
  //   setViewWhy5(false);
  //   setViewRCA(false);
  //   setViewTree(prevState => !prevState);
  //   setViewSolution(false);
  //   setViewActions(false);
  //   setViewKeywords(false);
  //   setViewMeasures(false);
  //   setViewOutcome(false);
  //   setViewAddl(false);
  // };

  // const handleSolutionExpansion = () => {
  //   setViewWhy1(false);
  //   setViewWhy2(false);
  //   setViewWhy3(false);
  //   setViewWhy4(false);
  //   setViewWhy5(false);
  //   setViewRCA(false);
  //   setViewTree(false);
  //   setViewSolution(prevState => !prevState);
  //   setViewActions(false);
  //   setViewKeywords(false);
  //   setViewMeasures(false);
  //   setViewOutcome(false);
  //   setViewAddl(false);
  // };

  // const handleActionsExpansion = () => {
  //   setViewWhy1(false);
  //   setViewWhy2(false);
  //   setViewWhy3(false);
  //   setViewWhy4(false);
  //   setViewWhy5(false);
  //   setViewRCA(false);
  //   setViewTree(false);
  //   setViewSolution(false);
  //   setViewActions(prevState => !prevState);
  //   setViewKeywords(false);
  //   setViewMeasures(false);
  //   setViewOutcome(false);
  //   setViewAddl(false);
  // };

  // const handleKeywordsExpansion = () => {
  //   setViewWhy1(false);
  //   setViewWhy2(false);
  //   setViewWhy3(false);
  //   setViewWhy4(false);
  //   setViewWhy5(false);
  //   setViewRCA(false);
  //   setViewTree(false);
  //   setViewSolution(false);
  //   setViewActions(false);
  //   setViewKeywords(prevState => !prevState);
  //   setViewMeasures(false);
  //   setViewOutcome(false);
  //   setViewAddl(false);
  // };

  // const handleMeasuresExpansion = () => {
  //   setViewWhy1(false);
  //   setViewWhy2(false);
  //   setViewWhy3(false);
  //   setViewWhy4(false);
  //   setViewWhy5(false);
  //   setViewRCA(false);
  //   setViewTree(false);
  //   setViewSolution(false);
  //   setViewActions(false);
  //   setViewKeywords(false);
  //   setViewMeasures(prevState => !prevState);
  //   setViewOutcome(false);
  //   setViewAddl(false);
  // };

  // const handleOutcomeExpansion = () => {
  //   setViewWhy1(false);
  //   setViewWhy2(false);
  //   setViewWhy3(false);
  //   setViewWhy4(false);
  //   setViewWhy5(false);
  //   setViewRCA(false);
  //   setViewTree(false);
  //   setViewSolution(false);
  //   setViewActions(false);
  //   setViewKeywords(false);
  //   setViewMeasures(false);
  //   setViewOutcome(prevState => !prevState);
  //   setViewAddl(false);
  // };

  // const handleAddlExpansion = () => {
  //   setViewWhy1(false);
  //   setViewWhy2(false);
  //   setViewWhy3(false);
  //   setViewWhy4(false);
  //   setViewWhy5(false);
  //   setViewRCA(false);
  //   setViewTree(false);
  //   setViewSolution(false);
  //   setViewActions(false);
  //   setViewKeywords(false);
  //   setViewMeasures(false);
  //   setViewOutcome(false);
  //   setViewAddl(prevState => !prevState);
  // };

  const [viewStates, setViewStates] = useState({
    viewImpact: false,
    viewWhy1: false,
    viewWhy2: false,
    viewWhy3: false,
    viewWhy4: false,
    viewWhy5: false,
    viewRCA: false,
    viewSolution: false,
    viewTree: false,
    viewActions: false,
    viewKeywords: false,
    viewMeasures: false,
    viewOutcome: false,
    viewAddl: false,
  });

  const handleExpansion = (key) => {
    setViewStates(prevState => {
      const newState = { ...prevState };
      for (const stateKey in newState) {
        newState[stateKey] = stateKey === key ? !newState[stateKey] : false;
      }
      return newState;
    });
  };

  const handleNavigateToExtensionExample = () => {
    navigate("/think5whys-extension-example"); 
  }

  // if (error) {
  //   return <div>Error: {error}</div>;
  // }

  // if (!rcaExtension) {
  //   return <div>Loading...</div>;
  // }
  
  return (
    <MainLayout>
      <div className="mt-12">
        <h3 className="text-lg mx-2 border-b border-b-gray-300 text-white">
          5 Why Analysis RCA Extension Details
        </h3>
      </div>
      <div>
        <div className="m-auto my-2 p-2 border-2 shadow-md rounded-md md:w-7/12 w-full text-white">
          <div className="mt-8 p-6 bg-gray-800 border border-gray-700 rounded-lg shadow-lg border-container">
            <div className="mb-6">
              <p className="text-white text-lg font-semibold mb-2">Important Information</p>
              <ul className="custom-bullets text-teal-300 pl-5 space-y-2 list-disc list-inside">
                <li>You must have ThinkWhys balance between Rs. 50.00 to Rs. 150.00.</li>
                <li>If you are using it for extensive self-analysis, the charge is Rs. 75.00.</li>
                <li>For Think5Whys certified person the charge is Rs. 50.00.</li>
                <li>If you are doing it for your client, the charge will be Rs. 150.00.</li>
                <li>On-the-fly Gen AI support request-response will be charged additionally.</li>
                <li>The visibility period for this data is 1 year from the date of creation.</li>
                <li>Afterward, it will be available free of charge for Think5Whys platform subscribers.</li>
              </ul>
            </div>

            <div className="text-white space-y-4">
              <div className="bg-gradient-to-r from-lime-600 to-lime-400 p-3 rounded-md">
                <p><strong>RCA Title:</strong> {rcaExtension.concernArea}</p>
              </div>
              <p><strong>Problem Statement:</strong> {rcaExtension.problemStatement}</p>
              <div className="bg-gradient-to-r from-lime-600 to-lime-400 p-3 rounded-md">
                <p><strong>Why1:</strong> {rcaExtension.why1}</p>
              </div>
              <p><strong>Why2:</strong> {rcaExtension.why2}</p>
              <div className="bg-gradient-to-r from-lime-600 to-lime-400 p-3 rounded-md">
                <p><strong>Why3:</strong> {rcaExtension.why3}</p>
              </div>
              <p><strong>Why4:</strong> {rcaExtension.why4}</p>
              <div className="bg-gradient-to-r from-lime-600 to-lime-400 p-3 rounded-md">
                <p><strong>Why5:</strong> {rcaExtension.why5}</p>
              </div>
              <p><strong>Root Cause:</strong> {rcaExtension.rootCause}</p>
              <div className="bg-gradient-to-r from-lime-600 to-lime-400 p-3 rounded-md">
                <p><strong>Problem Keywords:</strong> {rcaExtension.tags}</p>
              </div>
              <p><strong>Solution Note:</strong> {rcaExtension.quickSolutionsNote}</p>
              <div className="bg-gradient-to-r from-lime-600 to-lime-400 p-3 rounded-md">
                <p><strong>Action Note:</strong> {rcaExtension.quickSolutionsSelectionNote}</p>
              </div>
              <p><strong>Impact / Outcome Note:</strong> {rcaExtension.quickImpactNotes}</p>
              <div className="bg-gradient-to-r from-lime-600 to-lime-400 p-3 rounded-md">
                <p><strong>Category:</strong> {rcaExtension.category}</p>
              </div>
              <p><strong>Sub Category:</strong> {rcaExtension.subCategory}</p>
              <div className="bg-gradient-to-r from-lime-600 to-lime-400 p-3 rounded-md">
                <p><strong>Base RCA Code:</strong> {rcaExtension.rcaCode}</p>
              </div>
            </div>

            <div className="flex items-center mt-6">
              <label className="text-teal-200 text-sm">
                <input 
                  className='mr-2 accent-teal-500' 
                  type="checkbox" 
                  checked={isCheckedAISupport} 
                  onChange={(e) => setIsCheckedAISupport(!isCheckedAISupport)} 
                />
                I want to take Gen AI Support 
              </label>
              <Link to="/genai-price-List" className='ml-2 text-orange-400 underline hover:text-orange-500'>Click To View Charges</Link>
            </div>

            <div className='flex justify-center mt-8'>
              <button 
                className='w-64 bg-yellow-500 text-gray-900 py-3 font-semibold rounded-lg shadow-md hover:bg-yellow-600 transition-colors duration-300' 
                onClick={handleNavigateToExtensionExample}
              >
                Extensive Study Example
              </button>
            </div>

            <div className="flex justify-center mt-8">
              <CompleteRCAPDFGenerator rcaExtension={rcaExtension} />
            </div>
          </div>
          <div className="mt-6 p-4 rounded-lg shadow-lg border border-gray-300 bg-gray-800">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <button
                className="bg-yellow-200 text-blue-800 h-14 rounded-lg flex items-center justify-center text-center font-semibold transition-transform transform hover:scale-105"
                onClick={() => handleExpansion('viewImpact')}
              >
                Impact
              </button>
              <button
                className="bg-teal-400 text-blue-800 h-14 rounded-lg flex items-center justify-center text-center font-semibold transition-transform transform hover:scale-105"
                onClick={() => handleExpansion('viewWhy1')}
              >
                Why 1
              </button>
              <button
                className="bg-purple-400 text-yellow-100 h-14 rounded-lg flex items-center justify-center text-center font-semibold transition-transform transform hover:scale-105"
                onClick={() => handleExpansion('viewWhy2')}
              >
                Why 2
              </button>
              <button
                className="bg-blue-400 text-yellow-100 h-14 rounded-lg flex items-center justify-center text-center font-semibold transition-transform transform hover:scale-105"
                onClick={() => handleExpansion('viewWhy3')}
              >
                Why 3
              </button>
              <button
                className="bg-orange-400 text-yellow-100 h-14 rounded-lg flex items-center justify-center text-center font-semibold transition-transform transform hover:scale-105"
                onClick={() => handleExpansion('viewWhy4')}
              >
                Why 4
              </button>
              <button
                className="bg-red-700 text-yellow-100 h-14 rounded-lg flex items-center justify-center text-center font-semibold transition-transform transform hover:scale-105"
                onClick={() => handleExpansion('viewWhy5')}
              >
                Why 5
              </button>
              <button
                className="bg-yellow-200 text-blue-600 h-14 rounded-lg flex items-center justify-center text-center font-semibold transition-transform transform hover:scale-105"
                onClick={() => handleExpansion('viewRCA')}
              >
                RCA
              </button>
              <button
                className="bg-yellow-200 text-blue-600 h-14 rounded-lg flex items-center justify-center text-center font-semibold transition-transform transform hover:scale-105"
                onClick={() => handleExpansion('viewTree')}
              >
                Decision Map
              </button>
              <button
                className="bg-green-800 text-yellow-100 h-14 rounded-lg flex items-center justify-center text-center font-semibold transition-transform transform hover:scale-105"
                onClick={() => handleExpansion('viewSolution')}
              >
                Solutions
              </button>
              <button
                className="bg-blue-800 text-yellow-100 h-14 rounded-lg flex items-center justify-center text-center font-semibold transition-transform transform hover:scale-105"
                onClick={() => handleExpansion('viewActions')}
              >
                Actions
              </button>
              <button
                className="bg-purple-800 text-yellow-100 h-14 rounded-lg flex items-center justify-center text-center font-semibold transition-transform transform hover:scale-105"
                onClick={() => handleExpansion('viewKeywords')}
              >
                Keywords
              </button>
              <button
                className="bg-yellow-200 text-blue-600 h-14 rounded-lg flex items-center justify-center text-center font-semibold transition-transform transform hover:scale-105"
                onClick={() => handleExpansion('viewMeasures')}
              >
                Measures
              </button>
              <button
                className="bg-blue-800 text-yellow-100 h-14 rounded-lg flex items-center justify-center text-center font-semibold transition-transform transform hover:scale-105"
                onClick={() => handleExpansion('viewOutcome')}
              >
                Outcome
              </button>
              <button
                className="bg-teal-500 text-yellow-100 h-14 rounded-lg flex items-center justify-center text-center font-semibold transition-transform transform hover:scale-105"
                onClick={() => handleExpansion('viewAddl')}
              >
                Additional
              </button>
            </div>
          </div>

          {viewStates.viewImpact && (
          <>
            <div className="mt-6 p-6 rounded-lg shadow-lg bg-gray-800 border border-gray-200">
              {/* <h2 className="text-2xl font-semibold text-center text-yellow-200 mb-4">
                Impact Details
              </h2> */}
              <h2 className="text-2xl font-semibold text-center text-gray-800 mb-4 bg-yellow-200 p-2 rounded">
                Impact Details
              </h2>

              <div className="space-y-6">
                {rcaExtension.impact.map((impact, index) => (
                  <div key={index} className="space-y-2">
                    <p className="text-lg font-medium text-white">
                      Impact #{impact.sn}
                    </p>
                    <textarea
                      value={impact.details}
                      onChange={(e) => handleImpactChange(index, 'details', e.target.value)}
                      className="w-full h-36 p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-teal-400 resize-none"
                      placeholder="Describe the impact..."
                    />
                    {isCheckedAISupport && impact.details !== '' && (
                      <div className="mt-2">
                        <AILightComponent param1="Problem Statement" param2={impact.details} />
                      </div>
                    )}
                  </div>
                ))}

                <div className="space-y-4">
                  <div>
                    <p className="text-lg font-medium text-white">
                      Overall Impact
                    </p>
                    <textarea
                      name="overallImpact"
                      value={rcaExtension.overallImpact || ""}
                      onChange={handleInputChange}
                      className="w-full h-36 p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-teal-400 resize-none"
                      placeholder="Summarize the overall impact..."
                    />
                  </div>

                  <div>
                    <p className="text-lg font-medium text-white">
                      Summary of Impact/Affected Areas/Persons/Entities
                    </p>
                    <textarea
                      name="overallImpactOn"
                      value={rcaExtension.overallImpactOn || ""}
                      onChange={handleInputChange}
                      className="w-full h-36 p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-teal-400 resize-none"
                      placeholder="Detail the areas, persons, or entities affected..."
                    />
                  </div>

                  <div className="flex flex-col space-y-2">
                    <p className="text-lg font-medium text-white">
                      Overall Impact Severity
                    </p>
                    <input
                      type="text"
                      name="overallImpactSeverity"
                      value={rcaExtension.overallImpactSeverity || ""}
                      onChange={handleInputChange}
                      className="w-full bg-black p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-teal-400"
                      placeholder="Rate the severity of the overall impact..."
                    />
                  </div>
                </div>

                <div>
                  <p className="text-lg font-medium text-white">
                    Problem Statement Remarks
                  </p>
                  <textarea
                    name="problemStatementRemarks"
                    value={rcaExtension.problemStatementRemarks || ""}
                    onChange={handleInputChange}
                    className="w-full h-36 p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-teal-400 resize-none"
                    placeholder="Add any additional remarks on the problem statement..."
                  />
                </div>
              </div>
            </div>
          </>
        )}

          {viewStates.viewWhy1 && (
            <>
              <div className="mt-6 p-6 rounded-lg shadow-lg bg-gray-800 border border-gray-200">
                <h2 className="text-2xl font-semibold text-center text-gray-800 mb-4 bg-teal-300 p-2 rounded">
                  Why1 Details
                </h2>

                <div className="space-y-6">
                  {rcaExtension.why1reasons.map((why1reasons, index) => (
                    <div key={index} className="space-y-2">
                      <p className="text-lg font-medium text-white">
                        Why1 Reason #{why1reasons.sn}
                      </p>
                      <textarea
                        value={why1reasons.details}
                        onChange={(e) => handleWhy1Change(index, 'details', e.target.value)}
                        className="w-full h-36 p-3 border border-gray-300 rounded-lg shadow-sm bg-black text-white focus:outline-none focus:ring-2 focus:ring-teal-400 resize-none"
                        placeholder="Describe the reason for Why1..."
                      />
                      {isCheckedAISupport && why1reasons.details !== '' && (
                        <div className="mt-2">
                          <AILightComponent param1="Why 1" param2={why1reasons.details} />
                        </div>
                      )}
                    </div>
                  ))}

                  <div className="space-y-4">
                    <div>
                      <p className="text-lg font-medium text-white">
                        Why1 Selected Reason SN
                      </p>
                      <input
                        type="text"
                        name="why1SelectedSN"
                        value={rcaExtension.why1SelectedSN || ""}
                        onChange={handleInputChange}
                        className="w-16 p-3 border border-gray-300 rounded-lg shadow-sm bg-black text-white focus:outline-none focus:ring-2 focus:ring-teal-400"
                        placeholder="SN"
                      />
                    </div>

                    <div>
                      <p className="text-lg font-medium text-white">
                        Reason for Why1 Selection
                      </p>
                      <textarea
                        name="why1SNSelectedReason"
                        value={rcaExtension.why1SNSelectedReason || ""}
                        onChange={handleInputChange}
                        className="w-full h-36 p-3 border border-gray-300 rounded-lg shadow-sm bg-black text-white focus:outline-none focus:ring-2 focus:ring-teal-400 resize-none"
                        placeholder="Explain the selected SN..."
                      />
                    </div>
                  </div>

                  <div>
                    <p className="text-lg font-medium text-white">
                      Why1 Remarks
                    </p>
                    <textarea
                      name="why1remarks"
                      value={rcaExtension.why1remarks}
                      onChange={handleInputChange}
                      className="w-full h-36 p-3 border border-gray-300 rounded-lg shadow-sm bg-black text-white focus:outline-none focus:ring-2 focus:ring-teal-400 resize-none"
                      placeholder="Remarks, if any..."
                    />
                  </div>
                </div>
              </div>
            </>
          )}

          {viewStates.viewWhy2 && (
            <>
              <div className="mt-6 p-6 rounded-lg shadow-lg bg-gray-800 border border-gray-200">
                <h2 className="text-2xl font-semibold text-center text-gray-800 mb-4 bg-purple-400 p-2 rounded">
                  Why2 Details
                </h2>

                <div className="space-y-6">
                  {rcaExtension.why2reasons.map((why2reasons, index) => (
                    <div key={index} className="space-y-2">
                      <p className="text-lg font-medium text-white">
                        Why2 Reason #{why2reasons.sn}
                      </p>
                      <textarea
                        value={why2reasons.details}
                        onChange={(e) => handleWhy2Change(index, 'details', e.target.value)}
                        className="w-full h-36 p-3 border border-gray-300 rounded-lg shadow-sm bg-black text-white focus:outline-none focus:ring-2 focus:ring-purple-400 resize-none"
                        placeholder="Describe the reason for Why2..."
                      />
                      {isCheckedAISupport && why2reasons.details !== '' && (
                        <div className="mt-2">
                          <AILightComponent param1="Why 2" param2={why2reasons.details} />
                        </div>
                      )}
                    </div>
                  ))}

                  <div className="space-y-4">
                    <div>
                      <p className="text-lg font-medium text-white">
                        Why2 Selected Reason SN
                      </p>
                      <input
                        type="text"
                        name="why2SelectedSN"
                        value={rcaExtension.why2SelectedSN || ""}
                        onChange={handleInputChange}
                        className="w-16 p-3 border border-gray-300 rounded-lg shadow-sm bg-black text-white focus:outline-none focus:ring-2 focus:ring-purple-400"
                        placeholder="SN"
                      />
                    </div>

                    <div>
                      <p className="text-lg font-medium text-white">
                        Reason for Why2 Selection
                      </p>
                      <textarea
                        name="why2SNSelectedReason"
                        value={rcaExtension.why2SNSelectedReason || ""}
                        onChange={handleInputChange}
                        className="w-full h-36 p-3 border border-gray-300 rounded-lg shadow-sm bg-black text-white focus:outline-none focus:ring-2 focus:ring-purple-400 resize-none"
                        placeholder="Explain the selected SN..."
                      />
                    </div>
                  </div>

                  <div>
                    <p className="text-lg font-medium text-white">
                      Why2 Remarks
                    </p>
                    <textarea
                      name="why2remarks"
                      value={rcaExtension.why2remarks}
                      onChange={handleInputChange}
                      className="w-full h-36 p-3 border border-gray-300 rounded-lg shadow-sm bg-black text-white focus:outline-none focus:ring-2 focus:ring-purple-400 resize-none"
                      placeholder="Remarks, if any..."
                    />
                  </div>
                </div>
              </div>
            </>
          )}

          {viewStates.viewWhy3 && (
            <>
              <div className="mt-6 p-6 rounded-lg shadow-lg bg-gray-800 border border-gray-200">
                <h2 className="text-2xl font-semibold text-center text-gray-800 mb-4 bg-blue-400 p-2 rounded">
                  Why3 Details
                </h2>

                <div className="space-y-6">
                  {rcaExtension.why3reasons.map((why3reasons, index) => (
                    <div key={index} className="space-y-2">
                      <p className="text-lg font-medium text-white">
                        Why3 Reason #{why3reasons.sn}
                      </p>
                      <textarea
                        value={why3reasons.details}
                        onChange={(e) => handleWhy3Change(index, 'details', e.target.value)}
                        className="w-full h-36 p-3 border border-gray-300 rounded-lg shadow-sm bg-black text-white focus:outline-none focus:ring-2 focus:ring-blue-400 resize-none"
                        placeholder="Describe the reason for Why3..."
                      />
                      {isCheckedAISupport && why3reasons.details !== '' && (
                        <div className="mt-2">
                          <AILightComponent param1="Why 3" param2={why3reasons.details} />
                        </div>
                      )}
                    </div>
                  ))}

                  <div className="space-y-4">
                    <div>
                      <p className="text-lg font-medium text-white">
                        Why3 Selected Reason SN
                      </p>
                      <input
                        type="text"
                        name="why3SelectedSN"
                        value={rcaExtension.why3SelectedSN || ""}
                        onChange={handleInputChange}
                        className="w-16 p-3 border border-gray-300 rounded-lg shadow-sm bg-black text-white focus:outline-none focus:ring-2 focus:ring-blue-400"
                        placeholder="SN"
                      />
                    </div>

                    <div>
                      <p className="text-lg font-medium text-white">
                        Reason for Why3 Selection
                      </p>
                      <textarea
                        name="why3SNSelectedReason"
                        value={rcaExtension.why3SNSelectedReason || ""}
                        onChange={handleInputChange}
                        className="w-full h-36 p-3 border border-gray-300 rounded-lg shadow-sm bg-black text-white focus:outline-none focus:ring-2 focus:ring-blue-400 resize-none"
                        placeholder="Explain the selected SN..."
                      />
                    </div>
                  </div>

                  <div>
                    <p className="text-lg font-medium text-white">
                      Why3 Remarks
                    </p>
                    <textarea
                      name="why3remarks"
                      value={rcaExtension.why3remarks}
                      onChange={handleInputChange}
                      className="w-full h-36 p-3 border border-gray-300 rounded-lg shadow-sm bg-black text-white focus:outline-none focus:ring-2 focus:ring-blue-400 resize-none"
                      placeholder="Remarks, if any..."
                    />
                  </div>
                </div>
              </div>
            </>
          )}

          {viewStates.viewWhy4 && (
            <>
              <div className="mt-6 p-6 rounded-lg shadow-lg bg-gray-800 border border-gray-200">
                <h2 className="text-2xl font-semibold text-center text-gray-800 mb-4 bg-orange-400 p-2 rounded">
                  Why4 Details
                </h2>

                <div className="space-y-6">
                  {rcaExtension.why4reasons.map((why4reasons, index) => (
                    <div key={index} className="space-y-2">
                      <p className="text-lg font-medium text-white">
                        Why4 Reason #{why4reasons.sn}
                      </p>
                      <textarea
                        value={why4reasons.details}
                        onChange={(e) => handleWhy4Change(index, 'details', e.target.value)}
                        className="w-full h-36 p-3 border border-gray-300 rounded-lg shadow-sm bg-black text-white focus:outline-none focus:ring-2 focus:ring-orange-400 resize-none"
                        placeholder="Describe the reason for Why4..."
                      />
                      {isCheckedAISupport && why4reasons.details !== '' && (
                        <div className="mt-2">
                          <AILightComponent param1="Why 4" param2={why4reasons.details} />
                        </div>
                      )}
                    </div>
                  ))}

                  <div className="space-y-4">
                    <div>
                      <p className="text-lg font-medium text-white">
                        Why4 Selected Reason SN
                      </p>
                      <input
                        type="text"
                        name="why4SelectedSN"
                        value={rcaExtension.why4SelectedSN || ""}
                        onChange={handleInputChange}
                        className="w-16 p-3 border border-gray-300 rounded-lg shadow-sm bg-black text-white focus:outline-none focus:ring-2 focus:ring-orange-400"
                        placeholder="SN"
                      />
                    </div>

                    <div>
                      <p className="text-lg font-medium text-white">
                        Reason for Why4 Selection
                      </p>
                      <textarea
                        name="why4SNSelectedReason"
                        value={rcaExtension.why4SNSelectedReason || ""}
                        onChange={handleInputChange}
                        className="w-full h-36 p-3 border border-gray-300 rounded-lg shadow-sm bg-black text-white focus:outline-none focus:ring-2 focus:ring-orange-400 resize-none"
                        placeholder="Explain the selected SN..."
                      />
                    </div>
                  </div>

                  <div>
                    <p className="text-lg font-medium text-white">
                      Why4 Remarks
                    </p>
                    <textarea
                      name="why4remarks"
                      value={rcaExtension.why4remarks}
                      onChange={handleInputChange}
                      className="w-full h-36 p-3 border border-gray-300 rounded-lg shadow-sm bg-black text-white focus:outline-none focus:ring-2 focus:ring-orange-400 resize-none"
                      placeholder="Remarks, if any..."
                    />
                  </div>
                </div>
              </div>
            </>
          )}

          {viewStates.viewWhy5 && (
            <>
              <div className="mt-6 p-6 rounded-lg shadow-lg bg-gray-800 border border-gray-200">
                <h2 className="text-2xl font-semibold text-center text-gray-800 mb-4 bg-red-700 p-2 rounded">
                  Why5 Details
                </h2>

                <div className="space-y-6">
                  {rcaExtension.why5reasons.map((why5reasons, index) => (
                    <div key={index} className="space-y-2">
                      <p className="text-lg font-medium text-white">
                        Why5 Reason #{why5reasons.sn}
                      </p>
                      <textarea
                        value={why5reasons.details}
                        onChange={(e) => handleWhy5Change(index, 'details', e.target.value)}
                        className="w-full h-36 p-3 border border-gray-300 rounded-lg shadow-sm bg-black text-white focus:outline-none focus:ring-2 focus:ring-red-700 resize-none"
                        placeholder="Describe the reason for Why5..."
                      />
                      {isCheckedAISupport && why5reasons.details !== '' && (
                        <div className="mt-2">
                          <AILightComponent param1="Why 5" param2={why5reasons.details} />
                        </div>
                      )}
                    </div>
                  ))}

                  <div className="space-y-4">
                    <div>
                      <p className="text-lg font-medium text-white">
                        Why5 Selected Reason SN
                      </p>
                      <input
                        type="text"
                        name="why5SelectedSN"
                        value={rcaExtension.why5SelectedSN || ""}
                        onChange={handleInputChange}
                        className="w-16 p-3 border border-gray-300 rounded-lg shadow-sm bg-black text-white focus:outline-none focus:ring-2 focus:ring-red-700"
                        placeholder="SN"
                      />
                    </div>

                    <div>
                      <p className="text-lg font-medium text-white">
                        Reason for Why5 Selection
                      </p>
                      <textarea
                        name="why5SNSelectedReason"
                        value={rcaExtension.why5SNSelectedReason || ""}
                        onChange={handleInputChange}
                        className="w-full h-36 p-3 border border-gray-300 rounded-lg shadow-sm bg-black text-white focus:outline-none focus:ring-2 focus:ring-red-700 resize-none"
                        placeholder="Explain the selected SN..."
                      />
                    </div>
                  </div>

                  <div>
                    <p className="text-lg font-medium text-white">
                      Why5 Remarks
                    </p>
                    <textarea
                      name="why5remarks"
                      value={rcaExtension.why5remarks}
                      onChange={handleInputChange}
                      className="w-full h-36 p-3 border border-gray-300 rounded-lg shadow-sm bg-black text-white focus:outline-none focus:ring-2 focus:ring-red-700 resize-none"
                      placeholder="Remarks, if any..."
                    />
                  </div>
                </div>
              </div>
            </>
          )}

          {viewStates.viewRCA && (
            <>
              <div className="mt-6 p-6 rounded-lg shadow-lg bg-gray-800 border border-gray-200">
                <h2 className="text-2xl font-semibold text-center text-blue-800 mb-4 bg-yellow-200 p-2 rounded">
                  RCA Details
                </h2>

                <div className="space-y-6">
                  {rcaExtension.rcaCauses.map((rcaCauses, index) => (
                    <div key={index} className="space-y-2">
                      <p className="text-lg font-medium text-gray-800">
                        Root Cause #{rcaCauses.sn}
                      </p>
                      <textarea
                        value={rcaCauses.details}
                        onChange={(e) => handleRcaChange(index, 'details', e.target.value)}
                        className="w-full h-36 p-3 border border-gray-300 rounded-lg shadow-sm bg-black text-white focus:outline-none focus:ring-2 focus:ring-yellow-500 resize-none"
                        placeholder="Describe the root cause..."
                      />
                      {isCheckedAISupport && rcaCauses.details !== '' && (
                        <div className="mt-2">
                          <AILightComponent param1="Root Cause" param2={rcaCauses.details} />
                        </div>
                      )}
                    </div>
                  ))}

                  <div className="space-y-4">
                    <div>
                      <p className="text-lg font-medium text-gray-800">
                        Selected Cause SN
                      </p>
                      <input
                        type="text"
                        name="selectedCause"
                        value={rcaExtension.selectedCause || ""}
                        onChange={handleInputChange}
                        className="w-16 p-3 border border-gray-300 rounded-lg shadow-sm bg-black text-white focus:outline-none focus:ring-2 focus:ring-yellow-500"
                        placeholder="SN"
                      />
                    </div>

                    <div>
                      <p className="text-lg font-medium text-gray-800">
                        Reason for Root Cause Selection
                      </p>
                      <textarea
                        name="rootCause"
                        value={rcaExtension.rootCause || ""}
                        onChange={handleInputChange}
                        className="w-full h-36 p-3 border border-gray-300 rounded-lg shadow-sm bg-black text-white focus:outline-none focus:ring-2 focus:ring-yellow-500 resize-none"
                        placeholder="Explain the selected cause..."
                      />
                    </div>
                  </div>

                  <div>
                    <p className="text-lg font-medium text-gray-800">
                      RCA Remarks
                    </p>
                    <textarea
                      name="rcaRemarks"
                      value={rcaExtension.rcaRemarks}
                      onChange={handleInputChange}
                      className="w-full h-36 p-3 border border-gray-300 rounded-lg shadow-sm bg-black text-white focus:outline-none focus:ring-2 focus:ring-yellow-500 resize-none"
                      placeholder="Remarks, if any..."
                    />
                  </div>
                </div>
              </div>
            </>
          )}

          {viewStates.viewSolution && (
            <>
              <div className="mt-6 p-6 rounded-lg shadow-lg bg-gray-800 border border-gray-200">
                <h2 className="text-2xl font-semibold text-center text-yellow-100 mb-4 bg-green-700 p-2 rounded">
                  Probable Solutions Details
                </h2>

                <div className="space-y-6">
                  {rcaExtension.probableSolutions.map((probableSolutions, index) => (
                    <div key={index} className="space-y-2">
                      <p className="text-lg font-medium text-white">
                        Suggested Solution #{probableSolutions.sn}
                      </p>
                      <textarea
                        value={probableSolutions.details}
                        onChange={(e) => handleProbableSolutionsChange(index, 'details', e.target.value)}
                        className="w-full h-36 p-3 border border-gray-300 rounded-lg shadow-sm bg-black text-white focus:outline-none focus:ring-2 focus:ring-green-500 resize-none"
                        placeholder="Describe the suggested solution..."
                      />
                      {isCheckedAISupport && probableSolutions.details !== '' && (
                        <div className="mt-2">
                          <AILightComponent param1={`Suggested Solution ${probableSolutions.sn}`} param2={probableSolutions.details} />
                        </div>
                      )}
                    </div>
                  ))}

                  <div className="space-y-4">
                    <div>
                      <p className="text-lg font-medium text-white">
                        Selected Quick Fix Solution SN
                      </p>
                      <input
                        type="text"
                        name="selectedQFSolution"
                        value={rcaExtension.selectedQFSolution || ""}
                        onChange={handleInputChange}
                        className="w-16 p-3 border border-gray-300 rounded-lg shadow-sm bg-black text-white focus:outline-none focus:ring-2 focus:ring-green-500"
                        placeholder="SN"
                      />
                    </div>

                    <div>
                      <p className="text-lg font-medium text-white">
                        Reason for Quick Fix Solution Selection
                      </p>
                      <textarea
                        name="selectedQFSolutionRemarks"
                        value={rcaExtension.selectedQFSolutionRemarks || ""}
                        onChange={handleInputChange}
                        className="w-full h-36 p-3 border border-gray-300 rounded-lg shadow-sm bg-black text-white focus:outline-none focus:ring-2 focus:ring-green-500 resize-none"
                        placeholder="Explain the reason for quick fix solution selection..."
                      />
                      {isCheckedAISupport && rcaExtension.selectedQFSolutionRemarks !== '' && (
                        <div className="mt-2">
                          <AILightComponent param1="Reason for Quick Fix Solution Selection" param2={rcaExtension.selectedQFSolutionRemarks} />
                        </div>
                      )}
                    </div>

                    <div>
                      <p className="text-lg font-medium text-white">
                        Selected Long Term Solution SN
                      </p>
                      <input
                        type="text"
                        name="selectedLTSolution"
                        value={rcaExtension.selectedLTSolution || ""}
                        onChange={handleInputChange}
                        className="w-16 p-3 border border-gray-300 rounded-lg shadow-sm bg-black text-white focus:outline-none focus:ring-2 focus:ring-green-500"
                        placeholder="SN"
                      />
                    </div>

                    <div>
                      <p className="text-lg font-medium text-white">
                        Reason for Long Term Solution Selection
                      </p>
                      <textarea
                        name="selectedLTSolutionRemarks"
                        value={rcaExtension.selectedLTSolutionRemarks || ""}
                        onChange={handleInputChange}
                        className="w-full h-36 p-3 border border-gray-300 rounded-lg shadow-sm bg-black text-white focus:outline-none focus:ring-2 focus:ring-green-500 resize-none"
                        placeholder="Explain the reason for long term solution selection..."
                      />
                      {isCheckedAISupport && rcaExtension.selectedLTSolutionRemarks !== '' && (
                        <div className="mt-2">
                          <AILightComponent param1="Reason for Long Term Solution Selection" param2={rcaExtension.selectedLTSolutionRemarks} />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {viewStates.viewTree && (
            <>
              <div className="mt-6 p-6 rounded-lg shadow-lg bg-gray-800 border border-gray-200">
                <h2 className="text-2xl font-semibold text-center text-blue-700 mb-4 bg-yellow-300 p-2 rounded">
                  Decision Path / Route
                </h2>

                <div className="space-y-4">
                  <p className="text-lg font-medium text-gray-800">
                    Selected Reasons
                  </p>

                  <div className="space-y-3">
                    <p className="p-3 rounded-lg shadow-sm bg-lime-600 text-white">
                      <strong>Why1:</strong> {rcaExtension.why1SNSelectedReason}
                    </p>

                    <p className="p-3 rounded-lg shadow-sm bg-gray-100 text-gray-800">
                      <strong>Why2:</strong> {rcaExtension.why2SNSelectedReason}
                    </p>

                    <p className="p-3 rounded-lg shadow-sm bg-lime-600 text-white">
                      <strong>Why3:</strong> {rcaExtension.why3SNSelectedReason}
                    </p>

                    <p className="p-3 rounded-lg shadow-sm bg-gray-100 text-gray-800">
                      <strong>Why4:</strong> {rcaExtension.why4SNSelectedReason}
                    </p>

                    <p className="p-3 rounded-lg shadow-sm bg-lime-600 text-white">
                      <strong>Why5:</strong> {rcaExtension.why5SNSelectedReason}
                    </p>

                    <p className="p-3 rounded-lg shadow-sm bg-yellow-300 text-gray-800">
                      <strong>Solution:</strong> {rcaExtension.selectedLTSolutionRemarks}
                    </p>
                  </div>
                </div>
              </div>
            </>
          )}

          {viewStates.viewActions && (
            <>
              <div className="mt-6 p-6 rounded-lg shadow-lg bg-gray-800 border border-gray-200">
                <h2 className="text-2xl font-semibold text-center text-white mb-4 bg-blue-700 p-2 rounded">
                  Actions Log
                </h2>

                <div className="space-y-6">
                  {rcaExtension.solutionActions.map((solutionActions, index) => (
                    <div className="p-4 rounded-lg shadow-md bg-gray-700" key={index}>
                      <p className="text-lg font-semibold text-yellow-200 mb-4">
                        Solution Action #{solutionActions.sn}
                      </p>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                          <p className="text-sm font-medium text-white">Action Name/Title:</p>
                          <textarea
                            type="text"
                            value={solutionActions.actionItem}
                            onChange={(e) => handleSolutionActionChange(index, 'actionItem', e.target.value)}
                            className="p-2 mt-2 w-full h-24 rounded-md border border-gray-300 focus:border-green-500 focus:ring-2 focus:ring-green-200"
                          />
                        </div>

                        <div>
                          <p className="text-sm font-medium text-gray-700">Action Done By:</p>
                          <input
                            type="text"
                            value={solutionActions.who}
                            onChange={(e) => handleSolutionActionChange(index, 'who', e.target.value)}
                            className="p-2 mt-2 w-full rounded-md border border-gray-300 bg-black focus:border-green-500 focus:ring-2 focus:ring-green-200"
                          />
                        </div>

                        <div>
                          <p className="text-sm font-medium text-gray-700">Action Priority:</p>
                          <input
                            type="text"
                            value={solutionActions.priority}
                            onChange={(e) => handleSolutionActionChange(index, 'priority', e.target.value)}
                            className="p-2 mt-2 w-full rounded-md border border-gray-300 bg-black focus:border-green-500 focus:ring-2 focus:ring-green-200"
                          />
                        </div>

                        <div>
                          <p className="text-sm font-medium text-gray-700">Start Date:</p>
                          <DatePicker
                            selected={solutionActions.startDate}
                            onChange={(date) => handleSolutionActionChange(index, 'startDate', date)}
                            dateFormat="dd/MM/yyyy"
                            className="p-2 mt-2 w-full rounded-md border border-gray-300 bg-black focus:border-green-500 focus:ring-2 focus:ring-green-200"
                          />
                        </div>

                        <div>
                          <p className="text-sm font-medium text-gray-700">End Date:</p>
                          <DatePicker
                            selected={solutionActions.endDate}
                            onChange={(date) => handleSolutionActionChange(index, 'endDate', date)}
                            dateFormat="dd/MM/yyyy"
                            className="p-2 mt-2 w-full rounded-md border border-gray-300 bg-black focus:border-green-500 focus:ring-2 focus:ring-green-200"
                          />
                        </div>

                        <div>
                          <p className="text-sm font-medium text-gray-700">Action Status:</p>
                          <input
                            type="text"
                            value={solutionActions.status}
                            onChange={(e) => handleSolutionActionChange(index, 'status', e.target.value)}
                            className="p-2 mt-2 w-full rounded-md border border-gray-300 bg-black focus:border-green-500 focus:ring-2 focus:ring-green-200"
                          />
                        </div>
                      </div>

                      <div className="mt-4">
                        <p className="text-sm font-medium text-gray-700">Action Remarks:</p>
                        <textarea
                          type="text"
                          value={solutionActions.remarks}
                          onChange={(e) => handleSolutionActionChange(index, 'remarks', e.target.value)}
                          className="p-2 mt-2 w-full h-24 rounded-md border border-gray-300 focus:border-green-500 focus:ring-2 focus:ring-green-200"
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </>
          )}

          {viewStates.viewKeywords && (
            <div className="mt-4 border border-gray-700 rounded-lg text-sm p-4 bg-gray-900">
              <h2 className="text-white text-xl bg-purple-700 rounded-t-lg p-2 text-center">Keywords / KeyNote</h2>
              <div className="mt-4 space-y-4 border-container p-4">
                <div>
                  <label className="block text-white">Problem Keywords</label>
                  <input
                    type="text"
                    name="problemKeywords"
                    value={rcaExtension.problemKeywords || ""}
                    onChange={handleInputChange}
                    placeholder="Enter Problem Keywords"
                    style={{width: '100%'}}
                    className="bg-black text-white border border-gray-600 rounded-lg px-3 py-2 w-full focus:border-purple-500 focus:ring focus:ring-purple-500 focus:ring-opacity-50"
                  />
                  {isCheckedAISupport && rcaExtension.problemKeywords !== '' && (
                    <div className="mt-2">
                      <AILightComponent param1={"Problem Statement Final Keywords"} param2={rcaExtension.problemKeywords} />
                    </div>
                  )}
                </div>

                <div>
                  <label className="block text-white">Why1 Final Keywords</label>
                  <input
                    type="text"
                    name="why1Keywords"
                    value={rcaExtension.why1Keywords || ""}
                    onChange={handleInputChange}
                    placeholder="Enter Why1 Keywords"
                    style={{width: '100%'}}
                    className="bg-black text-white border border-gray-600 rounded-lg px-3 py-2 w-full focus:border-purple-500 focus:ring focus:ring-purple-500 focus:ring-opacity-50"
                  />
                  {isCheckedAISupport && rcaExtension.why1Keywords !== '' && (
                    <div className="mt-2">
                      <AILightComponent param1={"Why 1 Final Keywords"} param2={rcaExtension.why1Keywords} />
                    </div>
                  )}
                </div>

                <div>
                  <label className="block text-white">Why2 Final Keywords</label>
                  <input
                    type="text"
                    name="why2Keywords"
                    value={rcaExtension.why2Keywords || ""}
                    onChange={handleInputChange}
                    placeholder="Enter Why2 Keywords"
                    style={{width: '100%'}}
                    className="bg-black text-white border border-gray-600 rounded-lg px-3 py-2 w-full focus:border-purple-500 focus:ring focus:ring-purple-500 focus:ring-opacity-50"
                  />
                  {isCheckedAISupport && rcaExtension.why2Keywords !== '' && (
                    <div className="mt-2">
                      <AILightComponent param1={"Why 2 Final Keywords"} param2={rcaExtension.why2Keywords} />
                    </div>
                  )}
                </div>

                <div>
                  <label className="block text-white">Why3 Final Keywords</label>
                  <input
                    type="text"
                    name="why3Keywords"
                    value={rcaExtension.why3Keywords || ""}
                    onChange={handleInputChange}
                    placeholder="Enter Why3 Keywords"
                    style={{width: '100%'}}
                    className="bg-black text-white border border-gray-600 rounded-lg px-3 py-2 w-full focus:border-purple-500 focus:ring focus:ring-purple-500 focus:ring-opacity-50"
                  />
                  {isCheckedAISupport && rcaExtension.why3Keywords !== '' && (
                    <div className="mt-2">
                      <AILightComponent param1={"Why 3 Final Keywords"} param2={rcaExtension.why3Keywords} />
                    </div>
                  )}
                </div>

                <div>
                  <label className="block text-white">Why4 Final Keywords</label>
                  <input
                    type="text"
                    name="why4Keywords"
                    value={rcaExtension.why4Keywords || ""}
                    onChange={handleInputChange}
                    placeholder="Enter Why4 Keywords"
                    style={{width: '100%'}}
                    className="bg-black text-white border border-gray-600 rounded-lg px-3 py-2 w-full focus:border-purple-500 focus:ring focus:ring-purple-500 focus:ring-opacity-50"
                  />
                  {isCheckedAISupport && rcaExtension.why4Keywords !== '' && (
                    <div className="mt-2">
                      <AILightComponent param1={"Why 4 Final Keywords"} param2={rcaExtension.why4Keywords} />
                    </div>
                  )}
                </div>

                <div>
                  <label className="block text-white">Why5 Final Keywords</label>
                  <input
                    type="text"
                    name="why5Keywords"
                    value={rcaExtension.why5Keywords || ""}
                    onChange={handleInputChange}
                    placeholder="Enter Why5 Keywords"
                    style={{width: '100%'}}
                    className="bg-black text-white border border-gray-600 rounded-lg px-3 py-2 w-full focus:border-purple-500 focus:ring focus:ring-purple-500 focus:ring-opacity-50"
                  />
                  {isCheckedAISupport && rcaExtension.why5Keywords !== '' && (
                    <div className="mt-2">
                      <AILightComponent param1={"Why 5 Final Keywords"} param2={rcaExtension.why5Keywords} />
                    </div>
                  )}
                </div>

                <div>
                  <label className="block text-white">RCA Final Keywords</label>
                  <input
                    type="text"
                    name="rcaKeywords"
                    value={rcaExtension.rcaKeywords || ""}
                    onChange={handleInputChange}
                    placeholder="Enter RCA Keywords"
                    style={{width: '100%'}}
                    className="bg-black text-white border border-gray-600 rounded-lg px-3 py-2 w-full focus:border-purple-500 focus:ring focus:ring-purple-500 focus:ring-opacity-50"
                  />
                  {isCheckedAISupport && rcaExtension.rcaKeywords !== '' && (
                    <div className="mt-2">
                      <AILightComponent param1={"Root Cause Final Keywords"} param2={rcaExtension.rcaKeywords} />
                    </div>
                  )}
                </div>

                <div>
                  <label className="block text-white">Solution Keywords</label>
                  <textarea
                    name="solutionKeywords"
                    value={rcaExtension.solutionKeywords || ""}
                    onChange={handleInputChange}
                    placeholder="Enter Solution Keywords"
                    className="bg-black text-white border border-gray-600 rounded-lg px-3 py-2 w-full h-32 focus:border-purple-500 focus:ring focus:ring-purple-500 focus:ring-opacity-50"
                  />
                  {isCheckedAISupport && rcaExtension.solutionKeywords !== '' && (
                    <div className="mt-2">
                      <AILightComponent param1={"Solution Final Keywords"} param2={rcaExtension.solutionKeywords} />
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {viewStates.viewMeasures && (
            <>
              <div className="mt-4 border border-gray-700 rounded-lg text-sm p-4 bg-gray-900">
                <h2 className="text-blue-700 text-xl bg-yellow-200 rounded-t-lg p-2 text-center">
                  Measures Details
                </h2>
                <div className="mt-4 mb-2 flex flex-col border-container p-4">
                  <label className="text-white mb-1">Problem Measures</label>
                  <input
                    type="text"
                    name="problemMeasures"
                    value={rcaExtension.problemMeasures || ""}
                    onChange={handleInputChange}
                    placeholder="Problem Measures"
                    className="bg-black text-white border border-gray-400 p-2 mb-2 rounded"
                    style={{ width: "100%", boxSizing: "border-box" }}
                  />
                  {isCheckedAISupport && rcaExtension.problemMeasures !== '' && (
                    <div className="mb-2">
                      <AILightComponent param1={"Problem Measures"} param2={rcaExtension.problemMeasures} />
                    </div>
                  )}

                  <label className="text-white mb-1">Why1 Final Measures</label>
                  <input
                    type="text"
                    name="why1Measures"
                    value={rcaExtension.why1Measures || ""}
                    onChange={handleInputChange}
                    placeholder="Why1 Measures"
                    className="bg-black text-white border border-gray-400 p-2 mb-2 rounded"
                    style={{ width: "100%", boxSizing: "border-box" }}
                  />
                  {isCheckedAISupport && rcaExtension.why1Measures !== '' && (
                    <div className="mb-2">
                      <AILightComponent param1={"Why 1 Measures"} param2={rcaExtension.why1Measures} />
                    </div>
                  )}

                  <label className="text-white mb-1">Why2 Final Measures</label>
                  <input
                    type="text"
                    name="why2Measures"
                    value={rcaExtension.why2Measures || ""}
                    onChange={handleInputChange}
                    placeholder="Why2 Measures"
                    className="bg-black text-white border border-gray-400 p-2 mb-2 rounded"
                    style={{ width: "100%", boxSizing: "border-box" }}
                  />
                  {isCheckedAISupport && rcaExtension.why2Measures !== '' && (
                    <div className="mb-2">
                      <AILightComponent param1={"Why 2 Measures"} param2={rcaExtension.why2Measures} />
                    </div>
                  )}

                  <label className="text-white mb-1">Why3 Final Measures</label>
                  <input
                    type="text"
                    name="why3Measures"
                    value={rcaExtension.why3Measures || ""}
                    onChange={handleInputChange}
                    placeholder="Why3 Measures"
                    className="bg-black text-white border border-gray-400 p-2 mb-2 rounded"
                    style={{ width: "100%", boxSizing: "border-box" }}
                  />
                  {isCheckedAISupport && rcaExtension.why3Measures !== '' && (
                    <div className="mb-2">
                      <AILightComponent param1={"Why 3 Measures"} param2={rcaExtension.why3Measures} />
                    </div>
                  )}

                  <label className="text-white mb-1">Why4 Final Measures</label>
                  <input
                    type="text"
                    name="why4Measures"
                    value={rcaExtension.why4Measures || ""}
                    onChange={handleInputChange}
                    placeholder="Why4 Measures"
                    className="bg-black text-white border border-gray-400 p-2 mb-2 rounded"
                    style={{ width: "100%", boxSizing: "border-box" }}
                  />
                  {isCheckedAISupport && rcaExtension.why4Measures !== '' && (
                    <div className="mb-2">
                      <AILightComponent param1={"Why 4 Measures"} param2={rcaExtension.why4Measures} />
                    </div>
                  )}

                  <label className="text-white mb-1">Why5 Final Measures</label>
                  <input
                    type="text"
                    name="why5Measures"
                    value={rcaExtension.why5Measures || ""}
                    onChange={handleInputChange}
                    placeholder="Why5 Measures"
                    className="bg-black text-white border border-gray-400 p-2 mb-2 rounded"
                    style={{ width: "100%", boxSizing: "border-box" }}
                  />
                  {isCheckedAISupport && rcaExtension.why5Measures !== '' && (
                    <div className="mb-2">
                      <AILightComponent param1={"Why 5 Measures"} param2={rcaExtension.why5Measures} />
                    </div>
                  )}

                  <label className="text-white mb-1">RCA Final Measures</label>
                  <input
                    type="text"
                    name="rcaMeasures"
                    value={rcaExtension.rcaMeasures || ""}
                    onChange={handleInputChange}
                    placeholder="RCA Measures"
                    className="bg-black text-white border border-gray-400 p-2 mb-2 rounded"
                    style={{ width: "100%", boxSizing: "border-box" }}
                  />
                  {isCheckedAISupport && rcaExtension.rcaMeasures !== '' && (
                    <div className="mb-2">
                      <AILightComponent param1={"Root Cause Measures"} param2={rcaExtension.rcaMeasures} />
                    </div>
                  )}

                  <label className="text-white mb-1">Solution Measures</label>
                  <input
                    type="text"
                    name="solutionMeasures"
                    value={rcaExtension.solutionMeasures || ""}
                    onChange={handleInputChange}
                    placeholder="Solution Measures"
                    className="bg-black text-white border border-gray-400 p-2 mb-2 rounded"
                    style={{ width: "100%", boxSizing: "border-box" }}
                  />
                  {isCheckedAISupport && rcaExtension.solutionMeasures !== '' && (
                    <div className="mb-2">
                      <AILightComponent param1={"Solution Measures"} param2={rcaExtension.solutionMeasures} />
                    </div>
                  )}
                </div>
              </div>
            </>
          )}

          {viewStates.viewOutcome && (
            <>
              <div className="mt-4 border border-gray-700 rounded-lg text-sm p-4 bg-gray-900">
                <h2 className="text-white text-xl bg-blue-700 rounded-t-lg p-2 text-center">Outcomes Details</h2>
                <div className="mt-4 flex flex-col space-y-4 border-container ">
                  <div className="p-4">
                    <label className="text-white mb-2 block">Problem Outcome</label>
                    <input
                      type="text"
                      name="problemOutcome"
                      value={rcaExtension.problemOutcome || ""}
                      onChange={handleInputChange}
                      placeholder="Problem Outcome"
                      className="bg-black text-white border border-gray-400 p-2 rounded"
                      style={{
                        width: "100%",
                        boxSizing: "border-box",
                      }}
                    />
                    {isCheckedAISupport && rcaExtension.problemOutcome !== '' && (
                      <div className="mt-2">
                        <AILightComponent param1={"Problem Outcome"} param2={rcaExtension.problemOutcome}/>
                      </div>
                    )}
                  </div>

                  <div className="p-4">
                    <label className="text-white mb-2 block">Why1 Final Outcome</label>
                    <input
                      type="text"
                      name="why1Outcome"
                      value={rcaExtension.why1Outcome || ""}
                      onChange={handleInputChange}
                      placeholder="Why1 Outcome"
                      className="bg-black text-white border border-gray-400 p-2 rounded"
                      style={{
                        width: "100%",
                        boxSizing: "border-box",
                      }}
                    />
                    {isCheckedAISupport && rcaExtension.why1Outcome !== '' && (
                      <div className="mt-2">
                        <AILightComponent param1={"Why 1 Outcome"} param2={rcaExtension.why1Outcome}/>
                      </div>
                    )}
                  </div>

                  <div className="p-4">
                    <label className="text-white mb-2 block">Why2 Final Outcome</label>
                    <input
                      type="text"
                      name="why2Outcome"
                      value={rcaExtension.why2Outcome || ""}
                      onChange={handleInputChange}
                      placeholder="Why2 Outcome"
                      className="bg-black text-white border border-gray-400 p-2 rounded"
                      style={{
                        width: "100%",
                        boxSizing: "border-box",
                      }}
                    />
                    {isCheckedAISupport && rcaExtension.why2Outcome !== '' && (
                      <div className="mt-2">
                        <AILightComponent param1={"Why 2 Outcome"} param2={rcaExtension.why2Outcome}/>
                      </div>
                    )}
                  </div>

                  <div className="p-4">
                    <label className="text-white mb-2 block">Why3 Final Outcome</label>
                    <input
                      type="text"
                      name="why3Outcome"
                      value={rcaExtension.why3Outcome || ""}
                      onChange={handleInputChange}
                      placeholder="Why3 Outcome"
                      className="bg-black text-white border border-gray-400 p-2 rounded"
                      style={{
                        width: "100%",
                        boxSizing: "border-box",
                      }}
                    />
                    {isCheckedAISupport && rcaExtension.why3Outcome !== '' && (
                      <div className="mt-2">
                        <AILightComponent param1={"Why 3 Outcome"} param2={rcaExtension.why3Outcome}/>
                      </div>
                    )}
                  </div>

                  <div className="p-4">
                    <label className="text-white mb-2 block">Why4 Final Outcome</label>
                    <input
                      type="text"
                      name="why4Outcome"
                      value={rcaExtension.why4Outcome || ""}
                      onChange={handleInputChange}
                      placeholder="Why4 Outcome"
                      className="bg-black text-white border border-gray-400 p-2 rounded"
                      style={{
                        width: "100%",
                        boxSizing: "border-box",
                      }}
                    />
                    {isCheckedAISupport && rcaExtension.why4Outcome !== '' && (
                      <div className="mt-2">
                        <AILightComponent param1={"Why 4 Outcome"} param2={rcaExtension.why4Outcome}/>
                      </div>
                    )}
                  </div>

                  <div className="p-4">
                    <label className="text-white mb-2 block">Why5 Final Outcome</label>
                    <input
                      type="text"
                      name="why5Outcome"
                      value={rcaExtension.why5Outcome || ""}
                      onChange={handleInputChange}
                      placeholder="Why5 Outcome"
                      className="bg-black text-white border border-gray-400 p-2 rounded"
                      style={{
                        width: "100%",
                        boxSizing: "border-box",
                      }}
                    />
                    {isCheckedAISupport && rcaExtension.why5Outcome !== '' && (
                      <div className="mt-2">
                        <AILightComponent param1={"Why 5 Outcome"} param2={rcaExtension.why5Outcome}/>
                      </div>
                    )}
                  </div>

                  <div className="p-4">
                    <label className="text-white mb-2 block">RCA Final Outcome</label>
                    <input
                      type="text"
                      name="rcaOutcome"
                      value={rcaExtension.rcaOutcome || ""}
                      onChange={handleInputChange}
                      placeholder="RCA Outcome"
                      className="bg-black text-white border border-gray-400 p-2 rounded"
                      style={{
                        width: "100%",
                        boxSizing: "border-box",
                      }}
                    />
                    {isCheckedAISupport && rcaExtension.rcaOutcome !== '' && (
                      <div className="mt-2">
                        <AILightComponent param1={"Root Cause Outcome"} param2={rcaExtension.rcaOutcome}/>
                      </div>
                    )}
                  </div>

                  <div className="p-4">
                    <label className="text-white mb-2 block">Solution Outcome</label>
                    <input
                      type="text"
                      name="solutionOutcome"
                      value={rcaExtension.solutionOutcome || ""}
                      onChange={handleInputChange}
                      placeholder="Solution Outcome"
                      className="bg-black text-white border border-gray-400 p-2 rounded"
                      style={{
                        width: "100%",
                        boxSizing: "border-box",
                      }}
                    />
                    {isCheckedAISupport && rcaExtension.solutionOutcome !== '' && (
                      <div className="mt-2">
                        <AILightComponent param1={"Solution Outcome"} param2={rcaExtension.solutionOutcome}/>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}

            {viewStates.viewAddl && (
              <>
              <div className="mt-4 border border-gray-700 rounded-lg text-sm p-4 bg-gray-900">
                <h2 className="text-blue-800 text-xl bg-teal-300 h-8 rounded-t-lg flex justify-center">Summarisation & Additional Details</h2>
                <div className="mt-4 mb-2 flex flex-col border-container">
                    <p>Expert Deatils</p>
                    <input
                      type="text"
                      name="expertName"
                      value={rcaExtension.expertName || ""}
                      onChange={handleInputChange}
                      placeholder="Expert Name"
                      className="text-black mb-2"                      
                      style={{
                        border: "1px solid #ccc",
                        padding: "4px",
                        width: "400px",
                        boxSizing: "border-box",
                      }}
                    />
                    <input
                      type="text"
                      name="expertCode"
                      value={rcaExtension.expertCode || ""}
                      onChange={handleInputChange}
                      placeholder="Expert Code"
                      className="text-black mb-2"                      
                      style={{
                        border: "1px solid #ccc",
                        padding: "4px",
                        width: "100px",
                        boxSizing: "border-box",
                      }}
                    />
                    <p>Client Deatils</p>
                    <input
                      type="text"
                      name="clientName"
                      value={rcaExtension.clientName || ""}
                      onChange={handleInputChange}
                      placeholder="Client Name"
                      className="text-black mb-2"                      
                      style={{
                        border: "1px solid #ccc",
                        padding: "4px",
                        width: "400px",
                        boxSizing: "border-box",
                      }}
                    />
                    <input
                      type="text"
                      name="clientCode"
                      value={rcaExtension.clientCode || ""}
                      onChange={handleInputChange}
                      placeholder="Expert Code"
                      className="text-black mb-2"                      
                      style={{
                        border: "1px solid #ccc",
                        padding: "4px",
                        width: "100px",
                        boxSizing: "border-box",
                      }}
                    />
                    <p>Opening Remarks</p>
                    <textarea
                      type="text"
                      name="openingRemarks"
                      value={rcaExtension.openingRemarks || ""}
                      onChange={handleInputChange}
                      placeholder="Input...."
                      maxLength="2000"
                      className="text-black bg-white"                      
                      style={{
                        border: '1px solid #ccc',
                        padding: '2px',
                        backgroundColor: '#f0f0f0', 
                        color: '#000000',
                        height: '150px',
                        width: '100%', 
                      }}
                    />
                    {isCheckedAISupport && rcaExtension.openingRemarks!== '' && (
                      <div className="mb-1">
                        <AILightComponent param1={"Opening Remarks"} param2={rcaExtension.openingRemarks}/>
                      </div>
                    )}
                    <p>Closing Remarks</p>
                    <textarea
                      type="text"
                      name="closingRemarks"
                      value={rcaExtension.closingRemarks || ""}
                      onChange={handleInputChange}
                      placeholder="Input..."
                      maxLength="2000"
                      className="text-black bg-white"                      
                      style={{
                        border: '1px solid #ccc',
                        padding: '2px',
                        backgroundColor: '#f0f0f0', 
                        color: '#000000',
                        height: "150px", 
                        width: '100%', 
                      }}
                    />
                    {isCheckedAISupport && rcaExtension.closingRemarks!== '' && (
                      <div className="mb-1">
                        <AILightComponent param1={"Closing Remarks"} param2={rcaExtension.closingRemarks}/>
                      </div>
                    )}
                    <p>Assignment Start Date</p>
                    <input
                      type="date"
                      name="openingDate"
                      value={rcaExtension.openingDate || ""}
                      onChange={handleInputChange}
                      placeholder="Start Date"
                      className="text-black mb-2"                      
                      style={{
                        border: "1px solid #ccc",
                        padding: "4px",
                        width: "150px",
                        boxSizing: "border-box",
                        color: "black",
                      }}
                    />
                    <p>Assignment End Date</p>
                    <input
                      type="date"
                      name="closingDate"
                      value={rcaExtension.closingDate || ""}
                      onChange={handleInputChange}
                      placeholder="End Date"
                      className="text-black mb-2"                      
                      style={{
                        border: "1px solid #ccc",
                        padding: "4px",
                        width: "150px",
                        boxSizing: "border-box",
                        color: "black",
                      }}
                    />
                  </div>
                </div>
              </>
            )}
            <div className="flex flex-row justify-center mt-8 border-container">
              <button
                type="submit"
                className="mt-2 mb-2 ml-4 mr-4 bg-green-600 text-white px-4 py-2 font-medium"
                onClick={handleSubmit}
              >
                {rcaExists ? "Update" : "Save"}
              </button>
              <button
                className="mt-2 mb-2 ml-4 mr-4 bg-yellow-500 text-white px-4 py-2 font-medium"
                onClick={() => navigate("/rcas/:rcaId")}
              >
                Cancel
              </button>
            </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default RCAExtensionForm;
